import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { GrFormPrevious } from "react-icons/gr";
import { MdOutlineNavigateNext } from "react-icons/md";
import "../../Admin/css/pagination.css";
import moment from "moment/moment";
import axios from "axios";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import { BsCaretDownFill } from "react-icons/bs";
import { useSelector } from "react-redux";

const PER_PAGE = 25;

const Disputes = () => {
  const [Data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state?.auth?.user?.user);
  const [q, setQ] = useState("");
  const list = [
    "open",
    "seller_responded",
    "under_review",
    "resolved_refund",
    "resolved_release",
    "rejected",
  ];

  function searchData() {

    return Data.filter((user) => {
      if (q === "") {
        return user;
      } else if (user?.status.toLowerCase().includes(q.toLowerCase())) {
        return user;
      } else return user;
    });
  }
  const fetchRequests = () => {
    let config = {
      method: "post",
      url: Server2 + "/orders/get-disputes",
      data: {
        userId: userData._id
      },
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        console.log(response.data);
        response.data.sort(
          (b, c) => new Date(c.createdAt) - new Date(b.createdAt)
        );
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {	
    setLoading(true);
    fetchRequests();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //pagination function
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  const splitTwo = (str) => {
    return str.split('_').length < 2 ? str : str.split('_')[0] + " " + str.split('_')[1]
  }

  // const getProductDetails = (disputeProducts, allProducts, fname) => {
  //   return disputeProducts.map(dp => {
  //     const fullProduct = allProducts.find(p => p.productId === dp.productId);
  //     return (
  //       <div className="d-flex px-2 py-1">
  //         <div>
  //           <img
  //             src={ fullProduct.image ? fullProduct.image : "/img/upload-photo.png" }
  //             className="avatar avatar-sm me-2 rounded-1"
  //             alt="user1"
  //           />
  //         </div>
  //         <div className="d-flex flex-column justify-content-center">
  //           <h6 className="mb-0 text-sm text-capitalize ">{fullProduct.productName}</h6>
  //           <p className="text-xs text-secondary mb-0">By: {fname}</p>
  //         </div>
  //       </div>
  //     );
  //   });
  // };

  //pagination
  const offset = currentPage * PER_PAGE;
  const currentPageData = Data.length === 0 ? null : searchData().slice(offset, offset + PER_PAGE).map((dispute, index) => (
    <tbody key={index}>
      <tr>
        <td>
          {dispute.products.map(product => (
            <div className="d-flex px-2 py-1">
              <div>
                <img
                  src={
                    product.image
                      ? product.image
                      : "/img/upload-photo.png"
                  }
                  className="avatar avatar-sm me-2 rounded-1"
                  alt="user1"
                />
              </div>
              <div className="d-flex flex-column justify-content-center">
                <h6 className="mb-0 text-sm text-capitalize ">
                  {product.productName}
                </h6>
                <p className="text-xs text-secondary mb-0">
                  By: {dispute.seller.fname}
                </p>
              </div>
            </div>
          ))}
        </td>
        <td className="align-middle">
          {dispute.reason}
        </td>
        <td className="align-middle">
          <h6 className="lh-1 pt-1" style={{ pointer: "cursor", maxWidth: 270, textOverflow: 'ellipsis', overflowX: 'hidden' }} title={dispute.sellerResponse?.message}>
            {dispute.sellerResponse?.message ? dispute.sellerResponse.message : "-"}
          </h6>
        </td>
        <td className="align-middle text-center">
          <span
            className={`badge badge-sm ${
                dispute.status === "open" ? "bg-gradient-warning"
              : dispute.status === "seller_responded" ? "bg-gradient-primary"
              : dispute.status === 'resolved_refund' || dispute.status === 'resolved_released' ? "bg-gradient-success" 
              : "bg-gradient-danger"
            }`}
          >
            {splitTwo(dispute.status)}
          </span>
        </td>
        <td className="align-middle">
          {moment(dispute.createdAt).format("MMMM Do, YYYY  h:mm A")}
        </td>
      </tr>
    </tbody>
  ));

  const pageCount = Math.ceil(searchData().length / PER_PAGE);

  return ( loading ? (
    <div className="d-flex justify-content-center align-items-center">
      <div
        className="spinner-border"
        role="status"
        style={{ width: "6rem", height: "6rem", color: "#6148A1" }}
      >
        <span className="sr-only">.</span>
      </div>
    </div>
  ) : (
    <div className="container-fluid px-0" style={{}}>
      {Data.length > 0 && <>
      <div className="mb-3">
        <div className="d-flex align-items-center gap-3 fw-bold">
          <span className="fw-bolder px-3 py-2 rounded-2 text-white" style={{ backgroundColor: '#7dba38' }}>Disputes</span>
          <p className="fw-bold  text-dark">You created {Data.length} disputes from orders above</p>
        </div>
      </div>

      <div
        className="px-0 pt-0 pb-2 task"
        style={{ overflow: "auto" }}
      >
          
          <div className="table-responsive p-0">
            <table className="table align-items-center mb-0">
              <thead>
                <tr>
                  <th className="ps-0"><p className="border-bottom border-dark pb-1">Products</p></th>
                  <th className="ps-0"><p className="border-bottom border-dark pb-1">Reason</p></th>
                  <th className="ps-0"><p className="border-bottom border-dark pb-1">Seller's Response</p></th>
                  <th className="">
                    <Dropdown className="border-bottom border-dark pb-1">
                      <Dropdown.Toggle
                        className="border-0"
                        variant=""
                        id="dropdown-basic"
                        aria-expanded="false"
                      >
                        <span className="fs-6 fw-bold text-dark">
                          Status{" "}
                          <BsCaretDownFill size={12}/>
                        </span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu">
                      <Dropdown.Item
                        onClick={() => {
                          setQ("");
                        }}
                      >
                        <span className="fw-bold">
                          All Requests
                        </span>
                      </Dropdown.Item>
                        {
                          list.map((e) =>{
                            return(
                                <Dropdown.Item
                                onClick={() => {
                                  setQ(e);
                                }}
                              >
                                <span className="fw-bold">
                                  {e}
                                </span>
                              </Dropdown.Item>
                            )
                          })
                        }
                      </Dropdown.Menu>
                    </Dropdown>
                  </th>
                  <th className="ps-0"><p className="border-bottom border-dark pb-1">Last Processed</p></th>
                </tr>
              </thead>
              {currentPageData}
            </table>
          </div>

          {searchData().length > 24 ? (
            <div
              className=" mt-4"
              style={{
                padding: 2,
                boxSizing: "border-box",
                width: "100%",
              }}
            >
              <ReactPaginate
                activeClassName={"item active "}
                breakClassName={"item break-me "}
                breakLabel={"..."}
                containerClassName={"pagination"}
                t
                disabledClassName={"disabled-page"}
                marginPagesDisplayed={2}
                nextClassName={"item next "}
                nextLabel={
                  <MdOutlineNavigateNext
                    style={{ fontSize: 18, width: 150 }}
                  />
                }
                onPageChange={handlePageClick}
                pageCount={pageCount}
                pageClassName={"item pagination-page "}
                pageRangeDisplayed={2}
                previousClassName={"item previous"}
                previousLabel={
                  <GrFormPrevious
                    style={{ fontSize: 18, width: 150 }}
                  />
                }
              />
            </div>
          ) : null }

      </div>
      </> }
    </div>
  ));
};

export default Disputes;
